import { AbstractPmsApiService } from "./abstract.service";
import { BaseSubscription } from "../models";

/**
 * @class BaseSubscriptionPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<BaseSubscription>}
 */
export class BaseSubscriptionPmsApiService extends AbstractPmsApiService {

    /**
     * @propertyType {string}
     * @protected
     */
    get urlPattern() {

        return '/base-subscription(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {BaseSubscription}
     * @protected
     */
    newModel(attributes) {

        return new BaseSubscription(attributes);
    }

    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<BaseSubscription>>}
     */
    get (params = {}) {

        const url = this.url();

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {BaseSubscription} baseSubscription
     * @returns {Promise.<BaseSubscription>}
     */
    create(baseSubscription) {

        const url = this.url();

        return this.http
            .post(url, baseSubscription, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Integer} id
     * @param {Object} params
     */
    show(id, params = {}) {

        const url = this.url({
            id: id
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {BaseSubscription} baseSubscription
     * @returns {Promise.<BaseSubscription>}
     */
    update(baseSubscription) {

        const url = this.url({id: baseSubscription.id});

        return this.http
            .put(url, baseSubscription, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {BaseSubscription} baseSubscription
     * @returns {Promise.<boolean>}
     */
    delete(baseSubscription) {

        const url = this.url({id: baseSubscription.id});

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/base-subscription.service.js